import { Button, Container, Stack } from '@mui/material';
import { useFormik } from 'formik';
import { FC } from 'react';
import * as Yup from 'yup';
import {
    CustomTextField,
    generateTextFieldProps,
} from 'components/shared/form/custom-text-field';
import { MainQuestionVariationGuide } from 'api/hooks/main-question/mainQuestionsTypes';

type Props = {
    onAdd: (variationGuide: MainQuestionVariationGuide) => void;
    onCancel: () => void;
};

export const VariationGuideForm: FC<Props> = ({ onCancel, onAdd }) => {
    const formName = VariationGuideForm.name;
    const validationSchema = Yup.object({
        order_number: Yup.number().required('Required'),
        title: Yup.string().required('Required'),
        text: Yup.string().required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            order_number: '',
            title: '',
            text: '',
        },
        validationSchema,
        onSubmit: (data) => {
            onAdd({
                order: parseInt(data.order_number),
                title: data.title,
                text: data.text,
            });
        },
    });
    type FormikTypes = typeof formik.initialValues;

    return (
        <Container>
            <form onSubmit={formik.handleSubmit}>
                <Stack spacing={2}>
                    <Stack direction={'row'} spacing={2}>
                        <CustomTextField
                            {...generateTextFieldProps<FormikTypes>(
                                'order_number',
                                'Order Number',
                                formName,
                                formik
                            )}
                        />
                        <CustomTextField
                            {...generateTextFieldProps<FormikTypes>(
                                'title',
                                'Title',
                                formName,
                                formik
                            )}
                        />
                        <CustomTextField
                            {...generateTextFieldProps<FormikTypes>(
                                'text',
                                'Text',
                                formName,
                                formik
                            )}
                        />
                    </Stack>
                    <Stack direction={'row'} spacing={2}>
                        <Button variant='outlined' role='submit' type='submit'>
                            Add
                        </Button>
                        <Button variant='outlined' onClick={onCancel}>
                            Cancel
                        </Button>
                    </Stack>
                </Stack>
            </form>
        </Container>
    );
};
